<template>
  <div>
    <loading v-show="showLoader"/>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'ComplaintFeedback' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Complaint Detail</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div>
          <div class="row detail-header ib-align-start">
            <div class="col-md-6 col-lg-4 col-xl-3">
              <div class="detail-header-img">
              <div>
                <img class="img-fluid in-w-80" :src="require('@/assets/images/complaint-large-2x.png')" />
                <!-- <img class="img-fluid" :src="policy_detail.product.plan_image" v-if="policy_detail.product.plan_name != ''" /> -->
              </div>
              <div class="header-circle-img">
                <img class="img-fluid" :src="require('@/assets/images/complaint-large-2x.png')">
              </div>
            </div>
            </div>
            <div class="col-md-6 col-lg-6 col-xl-7 pl-lg-0">
              <h3 class="header-title"> {{ complaint_detail.complain_subject }}</h3>
              <div class="">
                <p class="header-td-first">Complaint Type: <span>{{ complaint_detail.complain_type }} </span><span style="color: #3d9cbd !important;"></span></p>
              </div>
              <div class="">
                <p class="header-td-first">Date: <span>{{ formatDate(complaint_detail.created_at) }} </span><span style="color: #3d9cbd !important;"></span></p>
              </div>
            </div>
            <div class="col-lg-2">
               <!-- style="position: relative; top: 2rem;" -->
              <div class="status-in-process text-capitalize mb-3">{{ complaint_detail.status }}</div>
            </div>
          </div>
          <div class="chat-desc b-b-dashed collapsible-link">
            <a style="pointer-events:none; cursor:none; margin-bottom:20px !important;" href="javascript:void(0)">Proposal Details</a>
            <p >{{ complaint_detail.description }}</p>
          </div>
          <div class="container mb-1 pb-1">
            <div class="row mb-5 jbl-chat-scroll jbl-height-scroll">
              <div class="col-md-12" v-for="message in complaint_chat">
                <!-- insurer / customer , please choose one type in one time-->
                <div v-if="message.user_type == 'insurer'" class="jbl-chat-1">
                  <div>
                    <div>
                      <div class="jbl-user-photo">
                        <img class="img-fluid" alt="Photo" :src="require('@/assets/images/admin-elipse-2x.png')">
                      </div>
                    </div>
                    <div class="jbl-chat-name">
                      <span class="jbl-chat-user ib-chat-time">Admin<br>{{ formatDate(message.created_at) }}</span>
                    </div>
                  </div>
                  <div>
                    <div class="chatbox-1">
                      <p>{{ message.message }}</p>
                    </div>
                  </div>
                </div>
                <div v-else class="jbl-chat-2">
                  <div>
                    <div class="chatbox-2">
                      <p>{{ message.message }}</p>
                    </div>
                  </div>
                  <div style="margin-left:.9rem;">
                    <div>
                      <div class="jbl-user-photo" style="margin-left: .7rem; margin-right:0 !important;">
                        <img class="img-fluid" alt="Photo" :src="$store.getters.getUser.avatar">
                      </div>
                    </div>
                    <div class="jbl-chat-name" style="text-align:center;">
                      <span class="jbl-chat-user ib-chat-time">{{ $store.getters.getUser.first_name }}<br>{{ formatDate(message.created_at) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="position-relative;">
              <form @submit="SendMessage" id="ChatForm">
                <div class="jbl-field">
                  <input type="text" name="message" class="jbl-dynamic-input chat-input" id="message" placeholder="Type Your Message Here" required>
                  <div class="position-relative">
                    <button type="submit" class="jbl-btn-aeroplane jbl-btn-in"><i class="fa fa-paper-plane"></i></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";


  export default {
    name: 'ComplaintView',
    components: {
      loading
    },
    data() {
      return {
        showLoader: false,
        complaint_detail: {},
        complaint_chat: {},
        user: {}
      };
    },
    created: function () {
      const self = this;
      self.showLoader = true;
      self.user = self.$store.getters.getUser;
      self.GetComplaintDetail(self.$route.params.id);
      this.sockets.subscribe('chatmessage', (data) => {
        if (data.complain_id == self.complaint_detail.id){
          self.GetComplaintDetail(self.$route.params.id);
        }
      });
    },
    sockets: {
      connect: function () {
        console.log('socket connected')
      },

      customEmit: function (data) {
        console.log('this method was fired by the socket server. eg: io.emit("chatmessage", data)')
      },
      chat: function (msg) {
        console.log("chat message received!: " + msg)
      }
    },
    methods: {
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },

      SendMessage(e) {
        const self = this;

        e.preventDefault();
        let message = document.getElementById('message').value;
        this.$socket.emit('chatmessage',
          {
            "user_type":"customer",
            "complain_id":self.complaint_detail.id,
            "message":message,
            "avatar": self.user.avatar,
            "commented_by":self.user.first_name +' ' + self.user.last_name,
            "comment_created_at":moment().format("HH:mm A, YYYY-MM-DD"),
            "customer_id":self.user.id
          }
        )

        var formData = new FormData(document.getElementById('ChatForm'));
        formData.append('complain_id', self.complaint_detail.id);
        axios.post('customer/complains/inquire', formData).then(function (resp) {

          if(resp.data.code == 200) {
            self.GetComplaintDetail(self.$route.params.id);
            document.getElementById('ChatForm').reset();
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });

      },
      async GetComplaintDetail(id) {
        const self = this;
        await axios.get('customer/complains/detail?complain_id=' + id).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.complaint_detail = resp.data.data;
            self.complaint_chat = resp.data.data.messages;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    },
    mounted() {

    }
  };
</script>



// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Complaint/View.vue